var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAthleteManagement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1072,
    height: 1094,
    viewBox: "0 0 1072 1094",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ddd",
    width: 1072,
    height: 1094
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "rgba(0,0,0,0.5)",
    fontFamily: "sans-serif",
    fontSize: 30,
    dy: 10.5,
    fontWeight: "bold",
    x: "50%",
    y: "50%",
    textAnchor: "middle"
  }, "RAP placeholder")));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAthleteManagement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/athleteManagement.a9ca1b86fbb5f518dac3741ea692fa30.svg";